import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export function Star({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 10.9994L4.29212 13L5.12013 8.98268L2 6.20177L6.21992 5.71937L8 2L9.78008 5.71937L14 6.20177L10.8799 8.98268L11.7079 13L8 10.9994ZM8 9.83803L10.2327 11.0425L9.73381 8.62392L11.6122 6.94919L9.07141 6.65884L8 4.41961L6.92859 6.65934L4.3878 6.94919L6.26619 8.62392L5.76728 11.0425L8 9.83803Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Globe({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM6.626 12.6002C6.03405 11.3446 5.69112 9.98613 5.6162 8.6H3.2372C3.35395 9.52334 3.73635 10.3929 4.33794 11.103C4.93953 11.8131 5.73441 12.3333 6.626 12.6002ZM6.818 8.6C6.9086 10.0634 7.3268 11.438 8 12.6512C8.69139 11.4059 9.09527 10.0217 9.182 8.6H6.818ZM12.7628 8.6H10.3838C10.3089 9.98613 9.96595 11.3446 9.374 12.6002C10.2656 12.3333 11.0605 11.8131 11.6621 11.103C12.2636 10.3929 12.646 9.52334 12.7628 8.6ZM3.2372 7.4H5.6162C5.69112 6.01387 6.03405 4.65541 6.626 3.3998C5.73441 3.66673 4.93953 4.18685 4.33794 4.89698C3.73635 5.6071 3.35395 6.47666 3.2372 7.4ZM6.8186 7.4H9.1814C9.09485 5.97836 8.69118 4.59412 8 3.3488C7.30861 4.59407 6.90473 5.97831 6.818 7.4H6.8186ZM9.374 3.3998C9.96595 4.65541 10.3089 6.01387 10.3838 7.4H12.7628C12.646 6.47666 12.2636 5.6071 11.6621 4.89698C11.0605 4.18685 10.2656 3.66673 9.374 3.3998Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Building({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 12.6667H14.6667V14H0V12.6667H1.33333V2.66667C1.33333 2.48986 1.40357 2.32029 1.5286 2.19526C1.65362 2.07024 1.82319 2 2 2H8.66667C8.84348 2 9.01305 2.07024 9.13807 2.19526C9.26309 2.32029 9.33333 2.48986 9.33333 2.66667V12.6667H12V7.33333H10.6667V6H12.6667C12.8435 6 13.013 6.07024 13.1381 6.19526C13.2631 6.32029 13.3333 6.48986 13.3333 6.66667V12.6667ZM2.66667 3.33333V12.6667H8V3.33333H2.66667ZM4 7.33333H6.66667V8.66667H4V7.33333ZM4 4.66667H6.66667V6H4V4.66667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Security({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.4785 2.162L7.5 1L12.5215 2.162C12.6572 2.19341 12.7786 2.27207 12.8656 2.38498C12.9526 2.4979 13 2.63833 13 2.78309V9.13845C13 9.76701 12.8509 10.3858 12.566 10.94C12.2812 11.4942 11.8694 11.9665 11.3671 12.3152L7.5 15L3.63289 12.3152C3.13072 11.9666 2.71895 11.4943 2.4341 10.9403C2.14926 10.3862 2.00014 9.76754 2 9.13909V2.78309C2.00002 2.63833 2.04745 2.4979 2.13444 2.38498C2.22143 2.27207 2.34279 2.19341 2.4785 2.162ZM3.22222 3.29345V9.13845C3.22223 9.55747 3.32157 9.97001 3.51144 10.3395C3.7013 10.7089 3.97581 11.0238 4.31061 11.2563L7.5 13.4708L10.6894 11.2563C11.0241 11.0239 11.2986 10.7091 11.4884 10.3397C11.6783 9.97041 11.7777 9.558 11.7778 9.13909V3.29345L7.5 2.30455L3.22222 3.29345ZM7.5 7.36364C7.09481 7.36364 6.70621 7.19602 6.4197 6.89767C6.13318 6.59932 5.97222 6.19466 5.97222 5.77273C5.97222 5.35079 6.13318 4.94614 6.4197 4.64778C6.70621 4.34943 7.09481 4.18182 7.5 4.18182C7.90519 4.18182 8.29379 4.34943 8.5803 4.64778C8.86682 4.94614 9.02778 5.35079 9.02778 5.77273C9.02778 6.19466 8.86682 6.59932 8.5803 6.89767C8.29379 7.19602 7.90519 7.36364 7.5 7.36364ZM4.7665 10.5455C4.84058 9.84444 5.16047 9.19654 5.66488 8.72591C6.16929 8.25529 6.82274 7.99504 7.5 7.99504C8.17726 7.99504 8.83071 8.25529 9.33512 8.72591C9.83953 9.19654 10.1594 9.84444 10.2335 10.5455H4.7665Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Loader({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.4241 2.70311C4.69429 1.60247 6.31929 0.997662 8 1.00001C11.8661 1.00001 15 4.1339 15 8C15 9.4952 14.531 10.8812 13.733 12.018L11.5 8H13.6C13.6001 6.90214 13.2775 5.82846 12.6723 4.91248C12.0671 3.9965 11.206 3.27862 10.196 2.84809C9.1861 2.41757 8.0719 2.2934 6.99197 2.49102C5.91204 2.68864 4.91402 3.19933 4.122 3.9596L3.4241 2.70311ZM12.5759 13.2969C11.3057 14.3975 9.68071 15.0023 8 15C4.1339 15 1 11.8661 1 8C1 6.5048 1.469 5.1188 2.267 3.982L4.5 8H2.4C2.39991 9.09786 2.72253 10.1715 3.32774 11.0875C3.93294 12.0035 4.79405 12.7214 5.80397 13.1519C6.8139 13.5824 7.9281 13.7066 9.00803 13.509C10.088 13.3114 11.086 12.8007 11.878 12.0404L12.5759 13.2969Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Paper({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3889 14H3.61111C3.44903 14 3.2936 13.9368 3.17899 13.8243C3.06438 13.7117 3 13.5591 3 13.4V2.6C3 2.44087 3.06438 2.28826 3.17899 2.17574C3.2936 2.06321 3.44903 2 3.61111 2H13.3889C13.551 2 13.7064 2.06321 13.821 2.17574C13.9356 2.28826 14 2.44087 14 2.6V13.4C14 13.5591 13.9356 13.7117 13.821 13.8243C13.7064 13.9368 13.551 14 13.3889 14ZM12.7778 12.8V3.2H4.22222V12.8H12.7778ZM5.44444 4.4H7.88889V6.8H5.44444V4.4ZM5.44444 8H11.5556V9.2H5.44444V8ZM5.44444 10.4H11.5556V11.6H5.44444V10.4ZM9.11111 5H11.5556V6.2H9.11111V5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Structure({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.66667 14C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.07024 2.32029 2.19526 2.19526C2.32029 2.07024 2.48986 2 2.66667 2H13.3333C13.5101 2 13.6797 2.07024 13.8047 2.19526C13.9298 2.32029 14 2.48986 14 2.66667V13.3333C14 13.5101 13.9298 13.6797 13.8047 13.8047C13.6797 13.9298 13.5101 14 13.3333 14H2.66667ZM5.33333 6.66667H3.33333V12.6667H5.33333V6.66667ZM12.6667 6.66667H6.66667V12.6667H12.6667V6.66667ZM12.6667 3.33333H3.33333V5.33333H12.6667V3.33333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Cart({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.1583 10V3.14286H2V2H3.73745C3.89105 2 4.03836 2.0602 4.14698 2.16737C4.25559 2.27453 4.31661 2.41988 4.31661 2.57143V9.42857H11.5201L12.6784 4.85714H5.47491V3.71429H13.4209C13.5089 3.71429 13.5958 3.73409 13.6749 3.77219C13.754 3.81029 13.8233 3.86569 13.8774 3.93416C13.9316 4.00264 13.9692 4.0824 13.9874 4.16738C14.0057 4.25235 14.004 4.34031 13.9826 4.42457L12.5348 10.1389C12.5034 10.2624 12.4311 10.3721 12.3293 10.4505C12.2275 10.5289 12.1021 10.5714 11.973 10.5714H3.73745C3.58385 10.5714 3.43654 10.5112 3.32793 10.4041C3.21932 10.2969 3.1583 10.1516 3.1583 10ZM4.31661 14C4.0094 14 3.71479 13.8796 3.49756 13.6653C3.28034 13.4509 3.1583 13.1602 3.1583 12.8571C3.1583 12.554 3.28034 12.2633 3.49756 12.049C3.71479 11.8347 4.0094 11.7143 4.31661 11.7143C4.62381 11.7143 4.91842 11.8347 5.13565 12.049C5.35287 12.2633 5.47491 12.554 5.47491 12.8571C5.47491 13.1602 5.35287 13.4509 5.13565 13.6653C4.91842 13.8796 4.62381 14 4.31661 14ZM11.2664 14C10.9592 14 10.6646 13.8796 10.4474 13.6653C10.2302 13.4509 10.1081 13.1602 10.1081 12.8571C10.1081 12.554 10.2302 12.2633 10.4474 12.049C10.6646 11.8347 10.9592 11.7143 11.2664 11.7143C11.5736 11.7143 11.8682 11.8347 12.0855 12.049C12.3027 12.2633 12.4247 12.554 12.4247 12.8571C12.4247 13.1602 12.3027 13.4509 12.0855 13.6653C11.8682 13.8796 11.5736 14 11.2664 14Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Academy({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.58333 2H12.9167C13.0714 2 13.2197 2.06146 13.3291 2.17085C13.4385 2.28025 13.5 2.42862 13.5 2.58333V13.8277C13.5 13.8763 13.4879 13.9242 13.4647 13.967C13.4415 14.0098 13.408 14.0461 13.3671 14.0726C13.3263 14.0991 13.2795 14.115 13.231 14.1187C13.1825 14.1225 13.1338 14.1141 13.0893 14.0942L8.25 11.9342L3.41067 14.0937C3.36628 14.1135 3.31763 14.1219 3.26916 14.1182C3.22068 14.1144 3.17391 14.0986 3.1331 14.0722C3.09229 14.0457 3.05874 14.0095 3.0355 13.9668C3.01225 13.9241 3.00005 13.8763 3 13.8277V2.58333C3 2.42862 3.06146 2.28025 3.17085 2.17085C3.28025 2.06146 3.42862 2 3.58333 2ZM12.3333 12.4796V3.16667H4.16667V12.4796L8.25 10.6572L12.3333 12.4796ZM8.25 8.70833L6.53558 9.60958L6.86283 7.70092L5.47625 6.34875L7.39308 6.06992L8.25 4.33333L9.1075 6.06992L11.0237 6.34875L9.63717 7.70092L9.96383 9.60958L8.25 8.70833Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Resources({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.3 5.33333H13.7V3.33333H3.3V5.33333ZM9.8 12.6667V6.66667H7.2V12.6667H9.8ZM11.1 12.6667H13.7V6.66667H11.1V12.6667ZM5.9 12.6667V6.66667H3.3V12.6667H5.9ZM2.65 2H14.35C14.5224 2 14.6877 2.07024 14.8096 2.19526C14.9315 2.32029 15 2.48986 15 2.66667V13.3333C15 13.5101 14.9315 13.6797 14.8096 13.8047C14.6877 13.9298 14.5224 14 14.35 14H2.65C2.47761 14 2.31228 13.9298 2.19038 13.8047C2.06848 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.06848 2.32029 2.19038 2.19526C2.31228 2.07024 2.47761 2 2.65 2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Calendar({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.25 3.1H13.45C13.5959 3.1 13.7358 3.15795 13.8389 3.26109C13.9421 3.36424 14 3.50413 14 3.65V12.45C14 12.5959 13.9421 12.7358 13.8389 12.8389C13.7358 12.9421 13.5959 13 13.45 13H3.55C3.40413 13 3.26424 12.9421 3.16109 12.8389C3.05795 12.7358 3 12.5959 3 12.45V3.65C3 3.50413 3.05795 3.36424 3.16109 3.26109C3.26424 3.15795 3.40413 3.1 3.55 3.1H5.75V2H6.85V3.1H10.15V2H11.25V3.1ZM12.9 6.4V4.2H11.25V5.3H10.15V4.2H6.85V5.3H5.75V4.2H4.1V6.4H12.9ZM12.9 7.5H4.1V11.9H12.9V7.5ZM5.2 8.6H7.95V10.8H5.2V8.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Newspaper({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.3333 12.6667V3.33335H3.33329V12.0834C3.33329 12.2381 3.39475 12.3864 3.50415 12.4958C3.61354 12.6052 3.76192 12.6667 3.91663 12.6667H10.3333ZM12.0833 13.8334H3.91663C3.4525 13.8334 3.00738 13.649 2.67919 13.3208C2.351 12.9926 2.16663 12.5475 2.16663 12.0834V2.75002C2.16663 2.59531 2.22808 2.44694 2.33748 2.33754C2.44688 2.22815 2.59525 2.16669 2.74996 2.16669H10.9166C11.0713 2.16669 11.2197 2.22815 11.3291 2.33754C11.4385 2.44694 11.5 2.59531 11.5 2.75002V6.83335H13.8333V12.0834C13.8333 12.5475 13.6489 12.9926 13.3207 13.3208C12.9925 13.649 12.5474 13.8334 12.0833 13.8334ZM11.5 8.00002V12.0834C11.5 12.2381 11.5614 12.3864 11.6708 12.4958C11.7802 12.6052 11.9286 12.6667 12.0833 12.6667C12.238 12.6667 12.3864 12.6052 12.4958 12.4958C12.6052 12.3864 12.6666 12.2381 12.6666 12.0834V8.00002H11.5ZM4.49996 4.50002H7.99996V8.00002H4.49996V4.50002ZM5.66663 5.66669V6.83335H6.83329V5.66669H5.66663ZM4.49996 8.58335H9.16663V9.75002H4.49996V8.58335ZM4.49996 10.3334H9.16663V11.5H4.49996V10.3334Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Question({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM8 12.8C9.27304 12.8 10.4939 12.2943 11.3941 11.3941C12.2943 10.4939 12.8 9.27304 12.8 8C12.8 6.72696 12.2943 5.50606 11.3941 4.60589C10.4939 3.70571 9.27304 3.2 8 3.2C6.72696 3.2 5.50606 3.70571 4.60589 4.60589C3.70571 5.50606 3.2 6.72696 3.2 8C3.2 9.27304 3.70571 10.4939 4.60589 11.3941C5.50606 12.2943 6.72696 12.8 8 12.8ZM7.4 9.8H8.6V11H7.4V9.8ZM8.6 8.813V9.2H7.4V8.3C7.4 8.14087 7.46321 7.98826 7.57574 7.87574C7.68826 7.76321 7.84087 7.7 8 7.7C8.17045 7.69999 8.33739 7.65158 8.4814 7.5604C8.6254 7.46922 8.74056 7.33902 8.81346 7.18495C8.88637 7.03088 8.91402 6.85928 8.89321 6.69011C8.8724 6.52093 8.80397 6.36115 8.6959 6.22935C8.58783 6.09754 8.44455 5.99914 8.28273 5.94558C8.12092 5.89203 7.94722 5.88552 7.78186 5.92682C7.61649 5.96813 7.46625 6.05554 7.34862 6.17889C7.23099 6.30224 7.15081 6.45646 7.1174 6.6236L5.9402 6.3878C6.01318 6.02305 6.18171 5.68422 6.42855 5.40595C6.6754 5.12768 6.99171 4.91995 7.34515 4.80399C7.6986 4.68803 8.07649 4.66801 8.44021 4.74597C8.80393 4.82393 9.14042 4.99707 9.41529 5.24769C9.69016 5.49832 9.89355 5.81744 10.0047 6.17244C10.1158 6.52743 10.1306 6.90557 10.0477 7.26818C9.9648 7.6308 9.78707 7.9649 9.53271 8.23632C9.27835 8.50774 8.95648 8.70675 8.6 8.813Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Write({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.46567 11.7939L12.7904 4.68407L11.7692 3.69282L4.44444 10.8026V11.7939H5.46567ZM6.06439 13.1959H3V10.2215L11.2586 2.20525C11.394 2.07383 11.5777 2 11.7692 2C11.9607 2 12.1444 2.07383 12.2798 2.20525L14.323 4.18845C14.4584 4.31991 14.5345 4.49818 14.5345 4.68407C14.5345 4.86996 14.4584 5.04823 14.323 5.17969L6.06439 13.1959ZM3 14.598H16V16H3V14.598Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Flow({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.58333 5.66669V10.3334C8.58333 10.7975 8.39896 11.2426 8.07077 11.5708C7.74258 11.899 7.29746 12.0834 6.83333 12.0834H5.5675C5.42989 12.4727 5.15905 12.8009 4.80286 13.0099C4.44667 13.2189 4.02807 13.2952 3.62104 13.2254C3.21401 13.1556 2.84477 12.9441 2.57857 12.6284C2.31238 12.3127 2.16638 11.913 2.16638 11.5C2.16638 11.087 2.31238 10.6874 2.57857 10.3716C2.84477 10.0559 3.21401 9.84444 3.62104 9.77463C4.02807 9.70482 4.44667 9.78116 4.80286 9.99014C5.15905 10.1991 5.42989 10.5273 5.5675 10.9167H6.83333C6.98804 10.9167 7.13642 10.8552 7.24581 10.7458C7.35521 10.6364 7.41667 10.4881 7.41667 10.3334V5.66669C7.41667 5.20256 7.60104 4.75744 7.92923 4.42925C8.25742 4.10106 8.70254 3.91669 9.16667 3.91669H10.9167V2.16669L13.8333 4.50002L10.9167 6.83335V5.08335H9.16667C9.01196 5.08335 8.86358 5.14481 8.75419 5.25421C8.64479 5.3636 8.58333 5.51198 8.58333 5.66669ZM3.91667 12.0834C4.07138 12.0834 4.21975 12.0219 4.32915 11.9125C4.43854 11.8031 4.5 11.6547 4.5 11.5C4.5 11.3453 4.43854 11.1969 4.32915 11.0875C4.21975 10.9781 4.07138 10.9167 3.91667 10.9167C3.76196 10.9167 3.61358 10.9781 3.50419 11.0875C3.39479 11.1969 3.33333 11.3453 3.33333 11.5C3.33333 11.6547 3.39479 11.8031 3.50419 11.9125C3.61358 12.0219 3.76196 12.0834 3.91667 12.0834Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function UIExtensions({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33333 3.33333H6V6H3.33333V3.33333ZM2 3.33333C2 2.59695 2.59695 2 3.33333 2H6C6.73638 2 7.33333 2.59695 7.33333 3.33333V6C7.33333 6.73638 6.73638 7.33333 6 7.33333H3.33333C2.59695 7.33333 2 6.73638 2 6V3.33333ZM3.33333 10H6V12.6667H3.33333V10ZM2 10C2 9.26362 2.59695 8.66667 3.33333 8.66667H6C6.73638 8.66667 7.33333 9.26362 7.33333 10V12.6667C7.33333 13.403 6.73638 14 6 14H3.33333C2.59695 14 2 13.403 2 12.6667V10ZM12.6667 3.33333H10V6H12.6667V3.33333ZM10 2C9.26362 2 8.66667 2.59695 8.66667 3.33333V6C8.66667 6.73638 9.26362 7.33333 10 7.33333H12.6667C13.403 7.33333 14 6.73638 14 6V3.33333C14 2.59695 13.403 2 12.6667 2H10ZM10 10H12.6667V12.6667H10V10ZM8.66667 10C8.66667 9.26362 9.26362 8.66667 10 8.66667H12.6667C13.403 8.66667 14 9.26362 14 10V12.6667C14 13.403 13.403 14 12.6667 14H10C9.26362 14 8.66667 13.403 8.66667 12.6667V10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Management({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 11H6.5V12H3V11ZM3 7.5H7.5V8.5H3V7.5ZM3 4H13V5H3V4ZM12.337 8.5125L12.915 8.317L13.415 9.183L12.957 9.5855C13.0146 9.85883 13.0146 10.1412 12.957 10.4145L13.415 10.817L12.915 11.683L12.337 11.4875C12.132 11.6725 11.888 11.815 11.6195 11.9025L11.5 12.5H10.5L10.38 11.902C10.1146 11.8153 9.87038 11.6739 9.663 11.487L9.085 11.683L8.585 10.817L9.043 10.4145C8.98535 10.1412 8.98535 9.85883 9.043 9.5855L8.585 9.183L9.085 8.317L9.663 8.5125C9.868 8.3275 10.112 8.185 10.3805 8.0975L10.5 7.5H11.5L11.62 8.098C11.888 8.185 12.132 8.328 12.337 8.513V8.5125ZM11 10.5C11.1326 10.5 11.2598 10.4473 11.3536 10.3536C11.4473 10.2598 11.5 10.1326 11.5 10C11.5 9.86739 11.4473 9.74021 11.3536 9.64645C11.2598 9.55268 11.1326 9.5 11 9.5C10.8674 9.5 10.7402 9.55268 10.6464 9.64645C10.5527 9.74021 10.5 9.86739 10.5 10C10.5 10.1326 10.5527 10.2598 10.6464 10.3536C10.7402 10.4473 10.8674 10.5 11 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Stack({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0141 10.348L14.8341 10.8283C14.8847 10.8579 14.9266 10.8997 14.9556 10.9498C14.9847 10.9999 15 11.0565 15 11.1141C15 11.1716 14.9847 11.2282 14.9556 11.2783C14.9266 11.3284 14.8847 11.3702 14.8341 11.3998L8.85133 14.9049C8.74522 14.9671 8.62378 15 8.5 15C8.37622 15 8.25478 14.9671 8.14867 14.9049L2.16589 11.3998C2.1153 11.3702 2.07343 11.3284 2.04436 11.2783C2.01528 11.2282 2 11.1716 2 11.1141C2 11.0565 2.01528 10.9999 2.04436 10.9498C2.07343 10.8997 2.1153 10.8579 2.16589 10.8283L2.98588 10.348L8.5 13.5787L14.0141 10.348ZM14.0141 7.21732L14.8341 7.69759C14.8847 7.72716 14.9266 7.76903 14.9556 7.81911C14.9847 7.86919 15 7.92578 15 7.98335C15 8.04092 14.9847 8.0975 14.9556 8.14758C14.9266 8.19767 14.8847 8.23954 14.8341 8.26911L8.5 11.98L2.16589 8.26911C2.1153 8.23954 2.07343 8.19767 2.04436 8.14758C2.01528 8.0975 2 8.04092 2 7.98335C2 7.92578 2.01528 7.86919 2.04436 7.81911C2.07343 7.76903 2.1153 7.72716 2.16589 7.69759L2.98588 7.21732L8.5 10.4479L14.0141 7.21732ZM8.85064 1.09513L14.8341 4.60019C14.8847 4.62976 14.9266 4.67163 14.9556 4.72171C14.9847 4.77179 15 4.82838 15 4.88595C15 4.94352 14.9847 5.0001 14.9556 5.05018C14.9266 5.10027 14.8847 5.14214 14.8341 5.17171L8.5 8.88259L2.16589 5.17171C2.1153 5.14214 2.07343 5.10027 2.04436 5.05018C2.01528 5.0001 2 4.94352 2 4.88595C2 4.82838 2.01528 4.77179 2.04436 4.72171C2.07343 4.67163 2.1153 4.62976 2.16589 4.60019L8.14867 1.09513C8.25478 1.03288 8.37622 1 8.5 1C8.62378 1 8.74522 1.03288 8.85133 1.09513H8.85064ZM8.5 2.44266L4.32979 4.88595L8.5 7.32923L12.6702 4.88595L8.5 2.44266Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Showcase({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17551 1L10.393 5.49298L14.0251 6.02091L13.8862 6.98658L10.2526 6.45767L9.74564 6.38407L9.51848 5.92439L8.17551 3.20286L6.83254 5.92439L6.60538 6.38407L6.09841 6.45767L3.09513 6.89396L5.26826 9.01297L5.63532 9.37029L5.54855 9.87579L5.03574 12.8669L7.20057 11.7287V12.8303L3.74054 14.6491L4.58775 9.71103L1 6.21345L5.95802 5.49298L8.17551 1ZM15 8.7995H9.15037V9.77444H15V8.7995ZM9.15037 10.7493H15V11.7242H9.15037V10.7493ZM9.15037 12.6993H13.0501V13.6742H9.15037V12.6993Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Community({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.25305 13.1473L2.16663 13.8333L2.85263 10.7469C2.40086 9.9019 2.16519 8.95822 2.16663 8.00001C2.16663 4.77826 4.77822 2.16667 7.99997 2.16667C11.2217 2.16667 13.8333 4.77826 13.8333 8.00001C13.8333 11.2218 11.2217 13.8333 7.99997 13.8333C7.04176 13.8348 6.09808 13.5991 5.25305 13.1473ZM5.42222 11.9148L5.80313 12.1189C6.47895 12.4801 7.2337 12.6683 7.99997 12.6667C8.92295 12.6667 9.8252 12.393 10.5926 11.8802C11.3601 11.3674 11.9582 10.6386 12.3114 9.78586C12.6646 8.93314 12.757 7.99483 12.577 7.08958C12.3969 6.18434 11.9524 5.35282 11.2998 4.70017C10.6472 4.04753 9.81563 3.60307 8.91039 3.42301C8.00514 3.24294 7.06683 3.33536 6.21411 3.68857C5.36139 4.04178 4.63255 4.63991 4.11977 5.40734C3.60699 6.17477 3.3333 7.07703 3.3333 8.00001C3.3333 8.77817 3.52288 9.52717 3.88163 10.1968L4.08522 10.5778L3.70313 12.2968L5.42222 11.9148Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GraphCMS({ className }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3999 2.86664L8.79997 3.80003L7.20003 4.73328L5.59995 5.66667V7.53331V8.46669V9.39995V10.3333V11.2667L7.20003 10.3333L8.79997 9.39995V8.46669V7.53331L7.20003 8.46669V6.60005L8.79997 5.66667L10.3999 4.73328V5.66667V6.60005V7.53331V8.46669V9.39995V10.3333L8.79997 11.2667L7.20003 12.2L5.59995 13.1334L4 14.0666L5.59995 15L7.20003 14.0666L8.79997 13.1334L10.3999 12.2L12 11.2667V9.39995V7.53331V5.66667V4.95074V3.80003V1.93339L10.3999 1V2.86664Z"
        fill="currentColor"
      />
    </svg>
  );
}
